import { Col, Form, Row } from "react-bootstrap";
import {
  CATEGORY_MEMBER_ROLES,
  SELECTABLE_MEMBER_ROLE_OPTIONS,
  buildMemberRoles,
  setMemberRoleAt,
} from "../utils/category.utils";

const roleLabel = (value) => {
  if (value === CATEGORY_MEMBER_ROLES.DRIVER) return "Driver";
  if (value === CATEGORY_MEMBER_ROLES.NAVIGATOR) return "Navigator";
  if (value === CATEGORY_MEMBER_ROLES.MECHANIC) return "Mechanic";
  return value || "";
};

/**
 * UI-only member role assignment based on max_members.
 * Not included in the create/update API payload yet.
 */
const MemberRolesFields = ({ form, onFieldChange, disabled = false }) => {
  const maxMembers = Math.max(1, Math.floor(Number(form.max_members)) || 1);
  const roles = buildMemberRoles(maxMembers, form.member_roles || []);
  const usePresetDropdowns = maxMembers === 2 || maxMembers === 3;

  const handleRoleChange = (index, value) => {
    onFieldChange(
      "member_roles",
      setMemberRoleAt(roles, index, value, maxMembers)
    );
  };

  return (
    <Col md={12}>
      <Form.Group className="mb-3">
        <Form.Label className="mb-2">Member roles</Form.Label>
        <Form.Text className="d-block text-muted mb-3">
          Seat 1 is always Driver. For 2–3 members, pick from Navigator /
          Mechanic. For more than 3, enter custom roles.
        </Form.Text>
        <Row>
          {roles.map((role, index) => {
            const seat = index + 1;
            const isDriver = index === 0;

            return (
              <Col md={4} key={`member-role-${seat}`} className="mb-2">
                <Form.Label className="small text-muted mb-1">
                  Seat {seat}
                </Form.Label>
                {isDriver ? (
                  <Form.Control
                    type="text"
                    value="Driver"
                    disabled
                    readOnly
                  />
                ) : usePresetDropdowns ? (
                  <Form.Select
                    value={
                      SELECTABLE_MEMBER_ROLE_OPTIONS.some(
                        (option) => option.value === role
                      )
                        ? role
                        : ""
                    }
                    onChange={(e) => handleRoleChange(index, e.target.value)}
                    disabled={disabled}
                  >
                    <option value="">Select role</option>
                    {SELECTABLE_MEMBER_ROLE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type="text"
                    value={roleLabel(role)}
                    onChange={(e) => handleRoleChange(index, e.target.value)}
                    placeholder={`Role for seat ${seat}`}
                    disabled={disabled}
                  />
                )}
              </Col>
            );
          })}
        </Row>
      </Form.Group>
    </Col>
  );
};

export default MemberRolesFields;
